/* unplugin-vue-components disabled */import script from "./xListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./xListItem.vue?vue&type=script&setup=true&lang=js"

import "./xListItem.vue?vue&type=style&index=0&id=79092315&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79092315"]])

export default __exports__